/* eslint-disable import/no-anonymous-default-export */
import { AxiosError } from "axios";
import useApi, { ActionResult, Api, Model, Query, Response } from "../common/hooks/useApi"
import { error } from "console";


export interface LotePrecarga extends Model {
    NroLote: string
    FechaHora: string
    Cantidad: number
}


const module = "LotePrecarga";

export default () => {
    const api = useApi({ module });

    return {
        list: (query: Query) => api.list!<LotePrecarga>(query),
        save: (data: Partial<LotePrecarga>) => api.save!<Partial<LotePrecarga>, LotePrecarga>(data),
        delete: (id: number) => api.delete(id),
        radarPreload: async () => {
            try {
                const response = await api.axiosInstance.post(`${module}/Radar/Precargar`);
                return {
                    data: {}
                };
            }
            catch (error: any | AxiosError) {

                return {
                    error
                };
            }
        },
        preload: async (configuracionPrecargaId: number) => {
            try {
                const ulrsPreload = process.env.REACT_APP_API_URL_PRELOAD?.split(",") ?? [];

                for (let url of ulrsPreload.reverse()) {
                    try {
                        console.log(`🚀 Iniciando precarga en: ${url}`);
                        await api.axiosInstance.post(`LotePrecarga/Precargar/${configuracionPrecargaId}`, null, { baseURL: url, timeout: (60 * 1000) });

                    } catch (errorPost: any | AxiosError) {

                        if (errorPost.toString().toLowerCase().includes('timeout')) {
                            console.info(`❌ Timeout 60s: ${url}`);
                            break;
                        }

                        console.log(`⚠️ ${errorPost} - Continuando con siguiente: ${url}`);
                        continue
                    }
                }

                return {
                    data: undefined
                };
            } catch (error: any | AxiosError) {

                return {
                    error
                };
            }
        }
    };
}